import React from 'react';
class LeftNavButton extends React.Component {
  render() {
    return <button {...this.props}>Next</button>  
  }
}
export default LeftNavButton;